angular.module('gym').controller('GymProfileCtrl', ["$scope", "$rootScope", "$http", "$stateParams", "$location", "GTMService", function($scope, $rootScope, $http, $stateParams, $location, GTMService) {
  $scope.gym = $rootScope.gym;
  $scope.serializableGym = $rootScope.serializableGym;
  $scope.dashboardVersion = window.currentUser.dashboard_settings.dashboard_version;
  $scope.isAccountOwner = window.currentUser.account_owner;
  $scope.currentTab = $location.search().tab || 'general';
  $scope.showSmsTab = $scope.gym.presented_gym_sms_detail.opt_out_policy_enabled;
  GTMService.trackPage('Account Profile - General');
  $scope.setTab = function(tab) {
    GTMService.trackPage('Account Profile - General', 'Tab change');
    $location.search({
      'tab': tab
    });
    return $scope.currentTab = tab;
  };
  return $scope.getProfile = function() {
    var url;
    url = `gyms/${$stateParams.gymId}/edit`;
    return $http.get(url);
  };
}]);
